import { render, staticRenderFns } from "./tags_list_select.vue?vue&type=template&id=0a7db304&"
import script from "./tags_list_select.vue?vue&type=script&lang=js&"
export * from "./tags_list_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports